import React from 'react'
import METODA_logo from './logo.png'
import Link from 'gatsby-link'
import $ from 'jquery';

class Main_menu extends React.Component {
  render() {
    if (typeof document !== 'undefined') {
      $(function() {
        $('.main-navigation-mobile').css('top', $('#mobile-menu-container').height() * (-1) );
        $('.header-toggle').click(
          function () {
          $('.main-navigation-mobile').toggleClass('active');
            //  console.log($('#mobile-menu-container').height());
          }
        );
        $('#link1, #link5').click(
          function(event) {
          event.preventDefault();
          slide('#Section-1'); hide_menu();
          }
        );
        $('#link2, #link6').click(
          function(event) {
          event.preventDefault();
          slide('#Section-2'); hide_menu();
          }
        );
        $('#link3, #link7').click(
          function(event) {
          event.preventDefault();
          slide('#Section-3'); hide_menu();
          }
        );
        $('#link4, #link8').click(
          function(event) {
          event.preventDefault();
          slide('#Section-4'); hide_menu();
          }
        );
        $('#link_o_nas').click(
          function(event) {
          event.preventDefault();
          slide('#Section-3');
          }
        );
        $( window ).scroll(function() {
          if ($(document).scrollTop() > 0) {
            $( ".site-header" ).css( "background-color", "rgb(212, 113, 115, 1)" );
          }
          else if ($(document).scrollTop() == 0) {
            $( ".site-header" ).css( "background-color", "rgb(212, 113, 115, 0)" );
          }
        });
        window.slide=function(direction){
          var elem = $(direction)
          if ( elem.length != 0 ) {
            var position = elem.offset().top - 79;
            $('html, body').animate({
              scrollTop: position
            }, 300);
          }
        };
        window.hide_menu=function(){
          $('.main-navigation-mobile').toggleClass('active');
        };
      });
    }
    return (
    <div className="site-header">
      <div className="body header-container">
        <div className="site-branding"><Link to="/" rel="Start"><img alt="metoda" title="metoda" className="header-image" src={METODA_logo}/></Link></div>	  	

      </div>
      
    </div>
    )
  }
}

export default Main_menu



// WEBPACK FOOTER //
// ./src/components/Main_menu.js